import 'angular-ui-bootstrap/src/typeahead/typeahead';
import 'angular-ui-bootstrap/src/position/position';
import 'angular-ui-bootstrap/src/debounce/debounce';

import typeaheadMatch from './typeahead-match.jade';
import typeaheadPopup from './typeahead-popup.jade';

export default angular.module('ui.cian.typeahead.adapter',
	['ui.bootstrap.typeahead',
		'ui.bootstrap.debounce',
		'ui.bootstrap.position'
	])
	.run(['$templateCache', ($templateCache) => {
		$templateCache.put('uib/template/typeahead/typeahead-match.html', typeaheadMatch);
		$templateCache.put('uib/template/typeahead/typeahead-popup.html', typeaheadPopup);
	}])
	.name;



// WEBPACK FOOTER //
// ./~/@cian/ui/app/adapters/ui.bootstrap.typeahead/typeahead.module.jsm